import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import {AppDateComponent, NgbdIslamicUmalqura} from '../components/app-date/app-date.component';
import {AppDateRangeComponent, NgbdIslamicRangeUmalqura} from '../components/app-date-range/app-date-range.component';
import {NumbersComponent} from '../components/app-numbers/app-numbers.component';
import {MessageModule} from 'primeng/message';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogModule, MessagesModule} from 'primeng/primeng';
import {PopoverModule} from 'ngx-popover';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SearchComponent} from "../components/search";
import {DropdownModule} from 'primeng/dropdown';
import {ShowButtonsComponent} from "../components/show-buttons/show-buttons.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PopoverModule,
    ConfirmDialogModule,
    DropdownModule,
    NgbModule.forRoot(),
    MessagesModule,
    MessageModule,
    TranslateModule.forChild()
  ],
  declarations: [AppDateComponent,NgbdIslamicUmalqura,AppDateRangeComponent,NgbdIslamicRangeUmalqura,SearchComponent,NumbersComponent,ShowButtonsComponent],
  exports: [ AppDateComponent,NgbdIslamicUmalqura,AppDateRangeComponent,NgbdIslamicRangeUmalqura,SearchComponent,NumbersComponent,ShowButtonsComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class MyInputsModule { }



// WEBPACK FOOTER //
// ./src/app/my-inputs/my-inputs.module.ts